import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=777df46f"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"
import style0 from "./InfoComponent.vue?vue&type=style&index=0&id=777df46f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports